
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/array-expansion",
      function () {
        return require("private-next-pages/syncs/array-expansion.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/array-expansion"])
      });
    }
  